import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { ProductUpdate } from 'modules/product_updates/types'

type Props = {
  module: ProductUpdate
  onClick: () => void
}

export const Item = ({ module, onClick }: Props) => {
  return (
    <Box key={module.id} flexDirection="row" gap="s8" onClick={onClick}>
      <Box
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
        border={{
          all: {
            width: 's1',
            color: 'grey300',
            style: 'solid',
          },
        }}
        style={{
          width: '100px',
          minWidth: '100px',
          height: '100%',
          maxHeight: '60px',
        }}
      >
        <img
          src={module.thumbnail.src}
          alt={module.title}
          style={{ borderRadius: '6px', width: '100%', height: '60px' }}
        />
      </Box>
      <Box>
        <Box className="text-black">
          <Text size="200" weight="medium" color="black">
            {module.title}
          </Text>
        </Box>
        <Box className="text-f1-foreground-secondary">
          {moment(module.releaseDate).format('DD/MM/YYYY')}
        </Box>
      </Box>
    </Box>
  )
}
